import { WidgetState } from "@nexus/widget-sdk";

export function EmptyDataState({
  className,
  title = "No data available",
  description = "No results for the current selection.",
}: {
  className?: string;
  title?: string;
  description?: string;
}) {
  return <WidgetState title={title} description={description} className={className} />;
}
